export default __webpack_public_path__ + "static/media/pantry1-afterI-1440w.859c77d0.png";